<template>
  <div
    :id="id"
    class="frame-content"
  >
    <iframe
      id="frame-operator"
      :src="pageFileName"
      width="100%"
      class="frame"
    />
  </div>
</template>

<script>
export default {
  name: 'HTMLLoadingWidget',
  props: {
    id: {
      type: String,
      default: '',
    },

    fileName: {
      type: String,
      default: '',
    },

    height: {
      type: Number,
      default: 0,
    },

    online: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageFileName: '',
      pageTitle: '',
    };
  },
  mounted() {
    if (this.online) {
      this.pageFileName = this.fileName;
    } else {
      this.pageFileName = '/static/htmls/' + this.fileName;
    }
    this.$nextTick(() => {
      window.addEventListener('message', this.receiveMessage);
    });
    if (this.height !== 0) {
      let divContainer = document.getElementById('' + this.id);
      divContainer.setAttribute('style', 'height:' + this.height + 'px');
    }
  },
  methods: {
    receiveMessage(event) {
      let height = event.data['frame_height'];
      const frame_id = event.data['id'];

      if (height) {
        height += 60;
        let divContainer = document.getElementById('' + this.id);
        if (divContainer !== null && frame_id === this.id) divContainer.setAttribute('style', 'height:' + height + 'px');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.frame-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: #f4f3ef;
  overflow: hidden;
}
.frame {
  flex-grow: 1;
  border: none;
  margin: 0;
  padding: 0;
}
hr {
  border: 1px solid grey;
  width: 100%;
}
h3 {
  text-align: center;
  margin: 0;
}
</style>
